import { type Observable } from 'rxjs'
import type { SystemNotification } from '@/features/notifications'
import type { NavigateFn } from '@/RootStore'
import { map } from 'rxjs/operators'
import { type Notification } from './Notification'

/**
 * Maps a stream of notifications to a stream of system notifications.
 *
 * @param notification$
 * @param navigate
 */
export function notificationsToSystemNotifications(
  notification$: Observable<Notification>,
  navigate: NavigateFn,
): Observable<SystemNotification> {
  return notification$.pipe(
    map((x): SystemNotification => ({
      title: x.recipient.workspace.name,
      body: x.plainText,
      tag: x.id || '',
      icon: x.imageUrl || undefined,
      onClick: () => (x.actionUrl ? navigate(x.actionUrl) : undefined),
    })),
  )
}
